import React from "react";
import { Boxes } from "../../components/background-boxes";
import { cn } from "../../lib/utils";
import { Element } from "react-scroll";

const Lastpage = () => {
  return (
    (<Element name="component4" className="component bg-slate-900">
        <div className="grid-cols-12 flex flex-col bg-slate-900">
        <div
            className="bg-slate-900 flex flex-col items-center justify-center rounded-lg font-sans">
            <div
                className=" bg-slate-900 z-20 [mask-image:radial-gradient(transparent,white)] pointer-events-none" />
            <h1 className={cn("md:text-5xl text-xl text-white relative z-20")}>
                Finally, because you're important to us
            </h1>
            <div className=" text-1_5xl pt-3 text-center mt-2 text-neutral-300 relative z-20">
                First 1000 users will have free access for lifetime!
                <br/>
                Be part of The Circle, an exclusive community of travelers

            </div>
        </div>
         </div>
      </Element>
    )
  );
}

export default Lastpage